import { render, staticRenderFns } from "./SelectMultipleOwner.vue?vue&type=template&id=0d7a544a&"
import script from "./SelectMultipleOwner.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports